export const FETCH_CMS = "FETCH_CMS";
export const FETCH_CMS_FAILURE = "FETCH_CMS_FAILURE";
export const FETCH_CMS_SUCCESS = "FETCH_CMS_SUCCESS";
